import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onSelect: (value: string) => void
  showJobData?: boolean
  showSenderData?: boolean
}

const AtsMessageVariablesSelectorComponent = ({ onSelect, showJobData, showSenderData }: Props) => {
  const candidateData: { id: string; label: string }[] = [
    {
      id: '{{candidate.first_name}}',
      label: i18n.t('ats.manage_message_templates.variables.candidate_first_name'),
    },
    {
      id: '{{candidate.last_name}}',
      label: i18n.t('ats.manage_message_templates.variables.candidate_last_name'),
    },
    {
      id: '{{candidate.email}}',
      label: i18n.t('ats.manage_message_templates.variables.candidate_email'),
    },
  ]
  const jobData: { id: string; label: string }[] = [
    {
      id: '{{job_opening.title}}',
      label: i18n.t('ats.manage_message_templates.variables.job_opening_title'),
    },
    {
      id: '{{job_opening.team}}',
      label: i18n.t('ats.manage_message_templates.variables.job_opening_team'),
    },
    {
      id: '{{job_opening.workplace}}',
      label: i18n.t('ats.manage_message_templates.variables.job_opening_workplace'),
    },
  ]
  const senderData: { id: string; label: string }[] = [
    {
      id: '{{sender.full_name}}',
      label: i18n.t('ats.manage_message_templates.variables.sender_full_name'),
    },
  ]
  const companyData: { id: string; label: string }[] = [
    {
      id: '{{company.name}}',
      label: i18n.t('ats.manage_message_templates.variables.company_name'),
    },
  ]

  // Company and cadidate data variables are always shown
  const getVariablesOptions = () => {
    const options = [...companyData]

    if (showSenderData) options.push(...senderData)
    options.push(...candidateData)
    if (showJobData) options.push(...jobData)

    return options
  }

  const variablesOptions = getVariablesOptions()

  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Text.Normal color="viridian1200" size="200" weight="medium">
            + {i18n.t('ats.manage_message_templates.add_variables')}
          </Text.Normal>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {variablesOptions.map((option) => (
            <PopoverMenu.TouchableOption
              title={option.label}
              onClick={() => onSelect(option.id)}
              key={option.id}
            />
          ))}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}

export const AtsMessageVariablesSelector = observer(AtsMessageVariablesSelectorComponent)
